import * as React from 'react';

import './scroll-top-button.css';

import { ScrollTopButtonProps } from '../../types';

class ScrollTopButton extends React.Component<ScrollTopButtonProps> {
  private scrollTopButtonAnchor: HTMLElement;

  public componentDidMount() {
    window.addEventListener('scroll', this.scrollListener);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollListener);;
  }

  public render() {
    const classNames = "scroll-top-button button has-background-grey has-text-white";
    const bottom = `${this.props.bottomOffset}%`;
    const right = `${this.props.rightOffset}%`;

    return (
      <a
          className={classNames}
          onClick={this.handleScrollTopClick}
          ref={anchor => this.scrollTopButtonAnchor = anchor!}
          style={{ bottom, right }}
      >
        {this.props.children}
      </a>
    );
  }

  /**
   * Listener for scroll event.
   */
  private scrollListener = () => {
    if (this.props.bottomSelector) {
      const bottomElement = document.querySelector(this.props.bottomSelector);

      if (bottomElement) {
        const windowHeight = window.innerHeight;
        const bottomElementTop = bottomElement.getBoundingClientRect().top;

        // If the top of the bottom element is less than windowHeight, then it is in view port
        // We need to make sure the button doesn't float into the bottom element.
        this.scrollTopButtonAnchor.style.bottom = (bottomElementTop < windowHeight)
            ? `${(windowHeight - bottomElementTop) / windowHeight * 100 + this.props.bottomOffset}%`
            : `${this.props.bottomOffset}%`;
      }
    }
  };

  private handleScrollTopClick = () => {
    const topElement = document.querySelector(this.props.topSelector);
    if (topElement) {
      topElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

}

export default ScrollTopButton;


// WEBPACK FOOTER //
// ./src/pages/profile/ScrollTopButton.tsx